module.exports = __webpack_public_path__ + "static/media/original-charts.50fc8f19.jpg";